import { render, staticRenderFns } from "./DatosCuentas.vue?vue&type=template&id=02275c91&scoped=true"
import script from "./DatosCuentas.vue?vue&type=script&lang=js"
export * from "./DatosCuentas.vue?vue&type=script&lang=js"
import style0 from "./DatosCuentas.vue?vue&type=style&index=0&id=02275c91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02275c91",
  null
  
)

export default component.exports